// extracted by mini-css-extract-plugin
export default {"OutSideArea":"confirm_OutSideArea__j002X","InSideArea":"confirm_InSideArea__+PGMo"};